import React, { createContext, useContext, useState, useEffect } from 'react';

const CompetitionContext = createContext();

export function useCompetition() {
  const context = useContext(CompetitionContext);
  if (!context) {
    throw new Error('useCompetition must be used within CompetitionProvider');
  }
  return context;
}

export function CompetitionProvider({ children }) {
  const [categories, setCategories] = useState([]);
  const [teams, setTeams] = useState([]);

  // Load data from localStorage on mount
  useEffect(() => {
    const savedCategories = localStorage.getItem('dance-timer-categories');
    const savedTeams = localStorage.getItem('dance-timer-teams');

    if (savedCategories) {
      setCategories(JSON.parse(savedCategories));
    }
    if (savedTeams) {
      setTeams(JSON.parse(savedTeams));
    }
  }, []);

  // Save categories to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem('dance-timer-categories', JSON.stringify(categories));
  }, [categories]);

  // Save teams to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem('dance-timer-teams', JSON.stringify(teams));
  }, [teams]);

  const value = {
    categories,
    setCategories,
    teams,
    setTeams
  };

  return (
    <CompetitionContext.Provider value={value}>
      {children}
    </CompetitionContext.Provider>
  );
}
